import React from 'react';

const defaultStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'center',
};

const CompoundExecutionSummaryGridCell = ({
  value,
  description,
  name,
  children,
  additionalStyle,
}) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexGrow: 1,
      flexShrink: 1,
      backgroundColor: 'rgb(247, 246, 244)',
    }}
  >
    <div style={{ ...defaultStyle, ...additionalStyle }}>
      <h3 style={{ margin: 0 }}>{name}</h3>
      {value != null ? ( // value may be 0 and we should display it, so don't use (value ? :) instead
        <h3 style={{ margin: 0 }}>{value}</h3>
      ) : null}
      {description ? (
        <h4 style={{ margin: 0, color: 'rgb(128, 128, 128)' }}>{description}</h4>
      ) : null}
    </div>
    {children}
  </div>
);

export default CompoundExecutionSummaryGridCell;
